export const SET_MODAL_DATA = 'contractCivilLow/SET_MODAL_DATA'

export const GET_XML = 'contractCivilLow/GET_XML'
export const GET_XML_DONE = 'contractCivilLow/GET_XML_CONT'
export const GET_XML_FAIL = 'contractCivilLow/GET_XML_CONT'

export const SEND_CONTRACT = 'contractCivilLow/SEND_CONTRACT'
export const SEND_CONTRACT_DONE = 'contractCivilLow/SEND_CONTRACT_DONE'
export const SEND_CONTRACT_FAIL = 'contractCivilLow/SEND_CONTRACT_FAIL'

export const GET_CONTRACTS = 'contractCivilLow/GET_CONTRACTS'
export const GET_CONTRACTS_DONE = 'contractCivilLow/GET_CONTRACTS_DONE'
export const GET_CONTRACTS_FAIL = 'contractCivilLow/GET_CONTRACTS_FAIL'

export const GET_CONTRACT = 'contractCivilLow/GET_CONTRACT'
export const GET_CONTRACT_DONE = 'contractCivilLow/GET_CONTRACT_DONE'
export const GET_CONTRACT_FAIL = 'contractCivilLow/GET_CONTRACT_FAIL'

export const SEND_SUB_CONTRACT = 'contractCivilLow/SEND_SUB_CONTRACT'
export const SEND_SUB_CONTRACT_DONE = 'contractCivilLow/SEND_SUB_CONTRACT_DONE'
export const SEND_SUB_CONTRACT_FAIL = 'contractCivilLow/SEND_SUB_CONTRACT_FAIL'

export const SEND_SUB_GET_XML = 'contractCivilLow/SEND_SUB_GET_XML'
export const SEND_SUB_GET_XML_DONE = 'contractCivilLow/SEND_SUB_GET_XML_DONE'
export const SEND_SUB_GET_XML_FAIL = 'contractCivilLow/SEND_SUB_GET_XML_FAIL'

export const SEND_DEL_GET_XML = 'contractCivilLow/SEND_DEL_GET_XML'
export const SEND_DEL_GET_XML_DONE = 'contractCivilLow/SEND_DEL_GET_XML_DONE'
export const SEND_DEL_GET_XML_FAIL = 'contractCivilLow/SEND_DEL_GET_XML_FAIL'

export const SEND_SUB_DEL_GET_XML = 'contractCivilLow/SEND_SUB_DEL_GET_XML'
export const SEND_SUB_DEL_GET_XML_DONE = 'contractCivilLow/SEND_SUB_DEL_GET_XML_DONE'
export const SEND_SUB_DEL_GET_XML_FAIL = 'contractCivilLow/SEND_SUB_DEL_GET_XML_FAIL'

export const SEND_TERM_GET_XML = 'contractCivilLow/SEND_TERM_GET_XML'
export const SEND_TERM_GET_XML_DONE = 'contractCivilLow/SEND_TERM_GET_XML_DONE'
export const SEND_TERM_GET_XML_FAIL = 'contractCivilLow/SEND_TERM_GET_XML_FAIL'

export const SEND_TERM = 'contractCivilLow/SEND_TERM'
export const SEND_TERM_DONE = 'contractCivilLow/SEND_TERM_DONE'
export const SEND_TERM_FAIL = 'contractCivilLow/SEND_TERM_FAIL'
